import type { InjectionKey } from 'vue';

/**
 * Provided (as `true`) by the overlay inspector host so column components that
 * can open inspector views know they are already rendering INSIDE the inspector.
 *
 * Inside the inspector, drill-downs (children lists, foreign-record side peeks)
 * must `inspectorStore.push()` so the back chevron returns to the record the
 * user came from; the same components in table cells keep `open()` (replace)
 * semantics — stacking unrelated rows would make Back a surprise tour.
 */
export const INSPECTOR_HOST: InjectionKey<boolean> = Symbol('inspector-host');
